module.exports = __webpack_public_path__ + "img/logo-gobierno.bdf05f28.png";